export function initLoadingPostBackHandler() {
    const pendingClassName = 'button--loading';
    const successClassName = 'button--success';
    const failClassName = 'button--fail';
    const stateDuration = 2000;
    dotvvm.postbackHandlers["loading-style-postback-handler"] = handlerOptions => ({
        async execute(callback, postbackOptions) {
            const button = (postbackOptions.sender as HTMLButtonElement);
            const showError = () => {
                button.classList.remove(pendingClassName);
                button.classList.add(failClassName);
                window.setTimeout(() => button.classList.remove(failClassName), stateDuration);
            };
            const showSuccess = () => {
                button.classList.remove(pendingClassName);
                button.classList.add(successClassName);
                return window.setTimeout(() => button.classList.remove(successClassName), stateDuration);
            };
            const handleException = e => {
                if (e.error === 'redirect') {
                    showSuccess();
                } else if (e.error && e.error.message == "Invalid action validationErrors") {
                    // ignore
                } else {
                    console.error(e);
                    showError();
                }
            };
            try {
                button.classList.add(pendingClassName);
                const postbackCommit = await callback();
                const removeSuccessTimeout = showSuccess();
                return (async () => {
                    try {
                        clearTimeout(removeSuccessTimeout);
                        button.classList.remove(successClassName);
                        button.classList.add(pendingClassName);
                        const postbackResult = await postbackCommit();
                        showSuccess();
                        return postbackResult;
                    } catch (e) {
                        handleException(e);
                        throw e;
                    }
                });
            } catch (e) {
                handleException(e);
                throw e;
            }
        }
    });
}